import { render, staticRenderFns } from "./close_button.vue?vue&type=template&id=280721f8"
import script from "./close_button.vue?vue&type=script&lang=js"
export * from "./close_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports